import { isDisabled } from '@testing-library/user-event/dist/utils';
import React, { Component, useState } from 'react';
import image1 from '../images/push-right.png';
import image2 from '../images/push-rightinner.png';
import ForecastRightFilterContent from './ForecastRightFilterContent';
import ImplementSetupRightFilterContent from './ImplementSetupRightFilterContent';

export default function ImplementSetupRightFilterToggle(props) {
    const [style, setStyle] = useState(" right-toggle-content filter-toggle ms-3");
    const [slide, setSlide] = useState({display: 'none'});
    const [flag, setflag] = useState(false);   
    const changeStyle = () => { 
        if (flag) {
            setStyle("right-toggle-content filter-toggle ms-3");
            setSlide({display: 'none'});
        }
        else {
            
            setSlide({display: 'block'});
            setStyle("right-toggle-content filter-hide ms-3"); 
             
        }

        setflag(!flag);
    };

    const searchOnClick = (selectedOwner, selectedCust, selectedLocationType, selectedLocationName, selectedServiceType, selectedFundingType, selectedContractCompleted, selectedServiceRegion, selectedImplementationStatus) => {
        debugger;
        props.onSearchClick(selectedOwner, selectedCust, selectedLocationType, selectedLocationName, selectedServiceType, selectedFundingType, selectedContractCompleted, selectedServiceRegion, selectedImplementationStatus);

    }

    const handleCheckboxClick = () => {
        props.onCheckboxClick();

    }

    return (
        <>
            <div className='sticky-right'>  
                <a href='#' className='toggle-panel' onClick={changeStyle} style={slide}><img src={image1}></img></a>
                <div className={style}>
                    <div className='panel-header d-flex justify-content-between p-2'>
                        <span >Filter</span> 
                        <a href='#' className='' onClick={changeStyle}><img src={image2}></img></a>
                    </div>
                    <div className='panel-body p-2 border-top-0 border rounded-bottom'>
                        <ImplementSetupRightFilterContent onSearchClick = {searchOnClick} onCheckboxClick={handleCheckboxClick} isCheckBoxHidden={props.isCheckBoxHidden} />
                    </div>
                </div>
            </div>

        </>

    )
}
